export default {"src":"/_next/static/media/error-icon.e9eb264d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};